/** A plain JSON object — a persisted spec is untrusted, user- or agent-authored JSON. */
export type JsonObject = Record<string, unknown>;

/**
 * The grammar a Custom chart's spec is written in. Vega-Lite is the concise,
 * high-level grammar; full Vega is for what Vega-Lite cannot express
 * (hierarchy and network layouts, custom signals and interactions).
 */
export type CustomChartGrammar = "vega-lite" | "vega";

/** A Custom chart: its spec, discriminated by the grammar it is written in. */
export type CustomChartSpec =
  | { grammar: "vega-lite"; spec: JsonObject }
  | { grammar: "vega"; spec: JsonObject };

/**
 * The name under which a Vega spec reads the host's dataset. A spec may
 * declare `{ "name": "table" }` (with `format`/`transform`) in its `data`, or
 * omit it; either way the host fills its `values`. Vega-Lite specs need no
 * name: the dataset is the spec's top-level data.
 */
export const VEGA_DATASET_NAME = "table";
